import { DateTime } from 'luxon';
import { graphql, type ResultOf } from '@/gql/graphql';

const IsEventStartedFragment = graphql(/* GraphQL */ `
  fragment IsEventStarted on event {
    datetime
  }
`);

export default function isEventStarted(
  datetime?: ResultOf<typeof IsEventStartedFragment>['datetime'],
) {
  const gameTime = DateTime.fromISO(datetime || '');
  const now = DateTime.now();

  return gameTime <= now;
}
